var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "terms-of-service-modal",
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "hide-header-close": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c(
                    "b-row",
                    {
                      staticClass: "w-100",
                      attrs: { "align-v": "center", "no-gutters": "" }
                    },
                    [
                      _c("b-col", [
                        _c("h2", { staticClass: "modal-title" }, [
                          _c("i", {
                            staticClass: "far fa-exclamation-circle mr-1"
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("xTermsOfServiceUpdate")) + " "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-row",
                    { staticClass: "box w-100", attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "secondary",
                            "data-test-hook":
                              "logout-button-terms-conditions-modal",
                            disabled: _vm.isLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.onLogout()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xLogout")) + " ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            "data-test-hook":
                              "continue-button-terms-conditions-modal",
                            disabled: _vm.isLoading
                          },
                          on: {
                            click: function($event) {
                              return _vm.onContinue()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xContinue")) + " ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c("p", [
                  _vm._v(" " + _vm._s(_vm.$t("xOur")) + " "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.termsConditionsUrl,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xTermsOfService")))]
                  ),
                  _vm._v(", "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.eulaUrl,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xEULA")))]
                  ),
                  _vm._v(", " + _vm._s(_vm.$t("xAnd")) + " "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.privacyPolicyUrl,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xPrivacyNotice")))]
                  ),
                  _vm._v(
                    " " + _vm._s(_vm.$t("xTermsOfServiceUpdateBody")) + " "
                  )
                ])
              ])
            ],
            1
          ),
          _c("b-row", { staticClass: "mt-2" }),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex align-items-start" },
                [
                  _c("b-form-checkbox", {
                    staticClass: "mr-2 mt-1",
                    attrs: {
                      "data-test-hook": "checkbox-terms-and-conditions-modal",
                      state: _vm.shouldShowCheckBoxError ? false : null,
                      disabled: _vm.isLoading
                    },
                    model: {
                      value: _vm.termsOfServiceAccepted,
                      callback: function($$v) {
                        _vm.termsOfServiceAccepted = $$v
                      },
                      expression: "termsOfServiceAccepted"
                    }
                  }),
                  _c("div", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xTermsOfServiceUpdateIAgree")) + " "
                    ),
                    !_vm.termsOfServiceAccepted && _vm.continuePressed
                      ? _c("div", { staticClass: "text-danger" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.$t("xTermsOfServiceUpdateMustAgree"))
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }